import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Firebase yapılandırması - Production Firestore
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "nqcagency.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "nqcagency",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "nqcagency.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || ""
};

// Firebase'i başlat
let app;
try {
  // Eğer apiKey yoksa Firebase'i başlatma
  if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "") {
    console.error('Firebase API Key is missing. Please create a .env file with your Firebase config.');
    app = null;
  } else {
    app = initializeApp(firebaseConfig);
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
  // Fallback config ile tekrar dene
  try {
    app = initializeApp({
      apiKey: "demo-key",
      authDomain: "nqcagency.firebaseapp.com",
      projectId: "nqcagency",
      storageBucket: "nqcagency.appspot.com",
      messagingSenderId: "123456789",
      appId: "1:123456789:web:demo"
    }, 'fallback');
  } catch (fallbackError) {
    console.error('Firebase fallback initialization also failed:', fallbackError);
  }
}

// Firestore'u başlat
let db;
let auth;

if (app) {
  try {
    db = getFirestore(app);
    auth = getAuth(app);

    // Emulator kullanımı - sadece açıkça istenirse (REACT_APP_USE_EMULATOR=true)
    // Production'da emulator kullanılmaz
    if (process.env.REACT_APP_USE_EMULATOR === 'true') {
      try {
        connectFirestoreEmulator(db, 'localhost', 8080);
        connectAuthEmulator(auth, 'http://localhost:9099');
      } catch (error) {
        if (error.message && !error.message.includes('already been initialized')) {
          console.warn('Firebase emulator connection error:', error);
        }
      }
    }
  } catch (error) {
    console.error('Firebase service initialization error:', error);
  }
} else {
  console.error('Firebase app is not initialized. Please check your .env file configuration.');
}

// Eğer db veya auth undefined ise, uygulamanın çökmesini önlemek için null olarak export et
export { db, auth };

export default app;

